import { IconProps } from '../types';

function PulseSolidAltIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-4 w-4'}
    >
      <path
        fillRule="evenodd"
        transform="matrix(0.83333,0,0,0.83333,0,0)"
        d="m14.3 20h-.2c-.9-.1-1.6-.7-1.8-1.6l-2.6-12.4-2.8 6.4c-.1.4-.5.6-.9.6h-3c-.6 0-1-.4-1-1s.4-1 1-1h2.3l2.5-5.8c.4-1 1.6-1.5 2.6-1 .6.3 1 .8 1.2 1.4l2.7 12.4 2.8-6.4c.2-.4.5-.6.9-.6h3c.6 0 1 .4 1 1s-.4 1-1 1h-2.3l-2.5 5.8c-.4.7-1.1 1.2-1.9 1.2z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default PulseSolidAltIcon;
